import axios from 'axios';
import { isDevelopment } from '../constants/env';
import redirectSignin from './redirectSignin';

/**
 * 配置 request 请求时的默认参数
 */
const request = axios.create({
  baseURL: isDevelopment ? '' : process.env.NEXT_PUBLIC_BACKEND_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// request.interceptors.request.use(config => {
//   const accessToken = getAccessToken();
//   if (accessToken) {
//     Object.assign(config.headers!, {
//       Authorization: `Bearer ${accessToken}`,
//     });
//   }
//   return config;
// });
request.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401 || error.response.status === 403) {
      console.log('====================================');
      console.log('redirect /signin');
      console.log('====================================');

      redirectSignin();
    }
  }
);

if (typeof window !== 'undefined') {
  // @ts-ignore
  window.request = request;
}
export default request;
